module.exports = __webpack_public_path__ + "static/media/red-truck-cut.81d81b68.png";